import { Box } from '@tempmee/react';
import { ISelectOption } from '~/commonComponents/InputSelect';
import { JobPostingStatus, JobPostingStatusMapper } from '~/domain/PermanentJobs';

export const JobPostingStatusOptions: ISelectOption[] = [
  {
    title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Active),
    value: JobPostingStatus.Active,
    PrefixComponent: (
      <Box
        height="10px"
        width="10px"
        className="rounded-full"
        style={{ backgroundColor: JobPostingStatusMapper.getColor(JobPostingStatus.Active) }}
      />
    ),
  },
  {
    title: JobPostingStatusMapper.toHumanReadable(JobPostingStatus.Closed),
    value: JobPostingStatus.Closed,
    PrefixComponent: (
      <Box
        height="10px"
        width="10px"
        className="rounded-full"
        style={{ backgroundColor: JobPostingStatusMapper.getColor(JobPostingStatus.Closed) }}
      />
    ),
  },
];
